export const LOCAL_STORAGE_KEYS = {
  ACCESS_TOKEN: 'access_token',
  USER_DATA: 'user_data',
  REFRESH_TOKEN: 'refresh_token',
  USER: 'user',
  REFRESHED: 'refreshed',
  AUTH_SET: 'auth_set',
}
